import dayjs from "dayjs";
import { CustomerT } from "../../../types";
import { CustomerContactInfo } from "./CustomerContactInfo";
import React from "react";
import TextCopy from "../../Reusable/TextCopy";

interface CustomerContactProps {
  customer: CustomerT;
}
export const CustomerContact: React.FC<CustomerContactProps> = ({
  customer,
}) => {
  const handleCall = (phoneNumber: string) => {
    window.open(`tel:${phoneNumber}`);
  };

  return (
    <div className="flex flex-col items-start justify-start w-full border bg-white rounded-[4px]  mt-6 md:mt-0 md:border ">
      <h2 className="bg-gray-50 w-full p-4">Cutomer Details</h2>
      <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between  w-full md:px-4 py-2">
        <CustomerContactInfo
          title="Created On"
          value={
            customer?.createdAt
              ? dayjs(customer.createdAt).format("MM/DD/YYYY")
              : "N/A"
          }
        />

        <CustomerContactInfo
          title="Business name"
          value={customer.businessName || "N/A"}
        />

        {/* <CustomerContactInfo
          title="Email Address"
          value={customer?.email || "N/A"}
        /> */}
        <CustomerContactInfo
          title="Address"
          value={customer.address || "N/A"}
        />
        <CustomerContactInfo
          title="Last Active"
          value={dayjs(customer?.createdAt).format("MM/DD/YYYY") || "N/A"}
        />

        <CustomerContactInfo title="State" value={customer?.state || "N/A"} />

        <CustomerContactInfo title="City" value={customer?.city || "N/A"} />

        <CustomerContactInfo
          border="0"
          title="Phone Number"
          value={customer?.phone || "N/A"}
          color="#5B21B6"
        />
      </div>
    </div>
  );
};
